export enum CSUrls {
    INTER = 'cocheseguro.inter.mx',
    INTER_QA = 'inter-autos-qa.web.app',
    CS_EMPLEADOS = 'empleadoscocheseguro.inter.mx',
    CS_SIVALE = 'cochesegurosivale.inter.mx',
    UVM = 'cochesegurouvm.inter.mx',
    UNITEC = 'cochesegurounitec.inter.mx',
    CS_1 = 'cocheseguro1.inter.mx',
    WALDOS = 'cochesegurowaldos.inter.mx',
    UAG = 'cochesegurouag.inter.mx',
    AS_DEPORTE = 'cocheseguroasdeporte.inter.mx',
    INTER_SECURITAS = 'cochesegurointersecuritas.inter.mx',
    UNIFIN_EMPLEADOS = 'cochesegurounifinempleados.inter.mx',
    UNIFIN = 'cochesegurounifin.inter.mx',
    SELLER = 'cocheseguro4seller.inter.mx',
    LOTTUS = 'cochesegurolottus.inter.mx',
    STONE = 'cochesegurostone.inter.mx',
    MANPOWER = 'cocheseguromanpower.inter.mx',
    CENEGAS = 'cochesegurocenagas.inter.mx',
    CLUB_PREMIER = 'cocheseguroclubpremier.inter.mx',
}